import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme: { spacing } }) => css`
    gap: ${spacing?.level3};
  `}
`;

export const Label = styled.label`
  ${({ theme: { font, colors } }) => css`
    ${font?.labelSmall}
    color: ${colors?.onSurfaceVariant};
  `}
`;

export const Grid = styled.div<{ $columns: number }>`
  display: grid;

  ${({ $columns, theme: { spacing } }) => css`
    grid-template-columns: repeat(${$columns}, minmax(0, 1fr));
    gap: ${spacing?.level3};
  `}

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const OtherInputRow = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme: { spacing } }) => css`
    margin-top: ${spacing?.level2};
    gap: ${spacing?.level2};
  `}
`;

export const ErrorText = styled.div`
  ${({ theme: { font, colors } }) => css`
    ${font?.bodySmall}
    color: ${colors?.error};
  `}
`;
